export const bookmarkColors = [
  {id:'lime',name:'Lime',hex:'#caff79'}, {id:'mint',name:'Mint',hex:'#8ce9b5'},
  {id:'sky',name:'Sky blue',hex:'#80cfff'}, {id:'indigo',name:'Indigo',hex:'#a6afff'},
  {id:'violet',name:'Violet',hex:'#d1a0ff'}, {id:'pink',name:'Pink',hex:'#ffa6d4'},
  {id:'coral',name:'Coral',hex:'#ff9d94'}, {id:'amber',name:'Amber',hex:'#ffc47d'},
  {id:'gold',name:'Gold',hex:'#f5e47d'}, {id:'teal',name:'Teal',hex:'#73dfdc'},
] as const;
export type BookmarkColor = typeof bookmarkColors[number]['id'];
export type BookmarkDetails = {folder:string;color:BookmarkColor};
export function validBookmark(value:unknown):value is BookmarkDetails {
  if(!value||typeof value!=='object'||Array.isArray(value))return false;
  const item=value as Record<string,unknown>;
  return typeof item.folder==='string'&&item.folder.length<=60&&item.folder===item.folder.trim()
    &&!/[\u0000-\u001f\u007f]/.test(item.folder)&&bookmarkColors.some(color=>color.id===item.color);
}
export const bookmarkHex=(details?:BookmarkDetails)=>bookmarkColors.find(color=>color.id===details?.color)?.hex;
